import {CLEAR_ERRORS, ERROR, LOADING, SUBMIT_FORM} from '../types';

export default (state, action) => {
  switch (action.type) {
    case SUBMIT_FORM:
      return {
        ...state,
        contacts: action.payload,
        error: null,
        loading: false
      }
    case ERROR:
      return {
        ...state,
        error: action.payload,
      }
    case LOADING:
      return {
        ...state,
        loading: true,
      }
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      }
    default:
      return state;
  }
}